export const apiKey = "docmaster-apikey";
export const apiKeyValue = "abcdef12345";
export const apiKeyAddTo = "header";

export const apiKeyHeader = () => {
  const db_name = localStorage.getItem("db_name");
  let header2Post = {};
  header2Post["content-type"] = "application/json";
  header2Post[apiKey] = apiKeyValue;
  header2Post["x-tenant-db"] = db_name || "";
  return header2Post;
};
